import { render, staticRenderFns } from "./CategoryReportTable.vue?vue&type=template&id=78ac45ba&scoped=true&"
import script from "./CategoryReportTable.vue?vue&type=script&lang=js&"
export * from "./CategoryReportTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryReportTable.vue?vue&type=style&index=0&id=78ac45ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac45ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDataTable,VFlex,VLayout})
